const actions = {
  SET_STATE: "session/SET_STATE",
  DELETE: "session/DELETE",
};

export default actions;
